import Vue from 'vue'
import Router from 'vue-router'

import Index from "@/views/index.vue"
import NewList from "@/views/home/newList.vue"
import productDetail from "@/views/home/productDetail.vue"
import about from "@/views/home/about.vue"
import contact from "@/views/home/contact.vue"
import Context from "@/views/home/context.vue"
import companyList from "@/views/home/companyList.vue"
import adList from "@/views/home/adList.vue"
Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'index',
    component: Index
  },
  {
    path: '/newList',
    name: 'newList',
    component: NewList
  },
  {
    path: '/productDetail',
    name: 'productDetail',
    component: productDetail
  },
  {
    path: '/about',
    name: 'about',
    component: about
  },
  {
    path: '/contact',
    name: 'contact',
    component: contact
  },
  {
    path: '/context',
    name: 'context',
    component: Context
  },
  {
    path: '/companyList',
    name: 'companyList',
    component: companyList
  },
  {
    path: '/adList',
    name: 'adList',
    component: adList
  }
  ]
})